var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3739 2.90191C19.8403 1.34773 22.3066 0.127298 24.4549 0C24.8145 2.12797 23.8214 4.19386 22.5116 5.67394C21.1086 7.25662 18.7652 8.50867 16.4306 8.44597C16.0039 6.4149 17.0491 4.31549 18.3739 2.90191ZM20.3469 9.64258C21.4873 9.07121 22.7427 8.44226 24.5822 8.44226C27.1255 8.44226 31.4004 10.7779 32.8649 13.3258C25.1064 15.5259 26.3939 26.1671 32.8649 27.839C31.9929 29.815 31.5302 30.7074 30.4048 32.4554C28.836 34.8968 26.6882 37.9785 23.9381 37.9994C22.8089 38.0091 22.0489 37.6667 21.2309 37.2981C20.2793 36.8694 19.2491 36.4053 17.4678 36.4186C15.7008 36.4277 14.7088 36.8849 13.7966 37.3052C13.0004 37.6721 12.2651 38.0109 11.1284 37.9994C7.11316 37.9994 0 29.1158 0 21.1112C0 12.3124 6.01013 8.57775 9.9639 8.57585C11.4865 8.57585 12.814 9.11859 14.0781 9.63546C15.2273 10.1053 16.3242 10.5538 17.4678 10.5538C18.5282 10.5538 19.3977 10.1181 20.3469 9.64258Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.bd2bf4add1899f4bbc427d4cbaa9c324.svg";
export { ForwardRef as ReactComponent };